import Vue from 'vue';
import VueSweetalert2 from 'vue-sweetalert2';

const options = {
	confirmButtonColor: '#ffb400',
	cancelButtonColor: '#ff0000'
}

Vue.use(VueSweetalert2, options);
